export default "/icons/postgres_icon.svg";